import axios from 'axios';

const KEY = 'vendor-session';
export const getVendorSession = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (_) { return null; } };
export const setVendorSession = data => { sessionStorage.setItem(KEY, JSON.stringify(data)); };
export const clearVendorSession = () => { sessionStorage.removeItem(KEY); };

// 供应商门户使用独立请求实例，避免供应商 JWT 覆盖内部员工的全局登录态。
export const vendorApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api'
});
vendorApi.interceptors.request.use(config => {
  const session = getVendorSession();
  if (session?.token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${session.token}`;
  }
  return config;
});
export const configureVendorAxios = () => vendorApi;
